import React from 'react';
import { useUser } from '../context/UserContext';

function HomePage() {

    const { user, logout } = useUser();

    /*
    if (!user) {
        return (
            <div className="container">
                <p>Please log in.</p>
            </div>
        );
    }
    */

    return (
        <div className="container">
            <div className='page-header'>
                <h1 className='gradient-under'>Creative Communications Postage Account Program</h1>
            </div>

            {user && (
                <h2 className="h4">Welcome, {user.firstName + ' ' + user.lastName}!</h2>
            )}
            {!user && (
                <h2 className='h4'>Welcome, please sign in.</h2>
            )}

            <p>UW Mailing Services processes postage charges for the University of Washington and UW Medicine through department postage accounts. Your postage account number is extremely important for acquiring the postage barcode that is pre-printed on envelopes, business reply products, and on the postage barcode stickers you can order from Mailing Services. You will be asked for your postage account number when you place orders for these products, and for certain types of mailings through Mail Prep.</p>
            <p>With this tool you can create a new postage account or add yourself to an existing postage account.</p>
            <p><b>Questions?</b> Contact <a href="mailto:barcode@uw.edu">barcode@uw.edu</a></p>
            <button className='btn btn-danger my-3' onClick={logout}>Log Out</button>
        </div>
    );
}

export default HomePage; // Default export
